/**
 * Adresse tenant pour en-têtes de tickets 80 mm.
 *
 * Rue sur la 1re ligne, « CP Ville » sur la 2e : une adresse concaténée
 * sur une seule ligne dépasse la largeur papier et coupe la ville en
 * plein mot (« Vaulx-en-V / elin » — constaté O'BRAISE 2026-08-26).
 */

type TenantAddressFields = {
  address?: string | null;
  postal_code?: string | null;
  city?: string | null;
};

/** Lignes d'adresse à imprimer (vide si pas d'adresse). */
export function tenantAddressLines(tenant: TenantAddressFields | null | undefined): string[] {
  if (!tenant?.address) return [];
  const cpVille = [tenant.postal_code, tenant.city].filter(Boolean).join(' ');
  return cpVille ? [tenant.address, cpVille] : [tenant.address];
}

/** Variante chaîne unique (séparateur \n) pour les champs texte type store_address. */
export function tenantAddressBlock(
  tenant: TenantAddressFields | null | undefined,
): string | undefined {
  const lines = tenantAddressLines(tenant);
  return lines.length ? lines.join('\n') : undefined;
}
